import PropTypes from 'prop-types';

//Themes maintained by ReCAPTCHA
const THEMES = ['light', 'dark'];

export const THEME_PROP_TYPE = PropTypes.oneOf(THEMES);
